module.exports = __webpack_public_path__ + "img/img_a@2x.3ea59981.png";